"use client"
import { useNavigate } from "react-router-dom"
import { FaArrowLeft } from "react-icons/fa"
import { useAppContext } from "../context/AppContext"
import TagForm from "../components/TagForm"
import "./TagFormPage.css"
import { AiOutlineLoading } from "react-icons/ai"

const CreateTagPage = () => {
  const navigate = useNavigate()
  const { addTag, loadingApp } = useAppContext()

  const handleSubmit = (tagData) => {
    addTag(tagData)
    navigate("/tags")
  }

  return (
    <div className="tag-form-page">
            {loadingApp && <div className="loading"><AiOutlineLoading size="50px"/></div>}
      
      <div className="page-header">
        <h1 className="page-title">Nova Etiqueta</h1>
        <button className="btn btn-secondary" onClick={() => navigate("/tags")}>
          <FaArrowLeft className="icon-left" /> Voltar
        </button>
      </div>

      <div className="form-container">
        <TagForm onSubmit={handleSubmit} />
      </div>
    </div>
  )
}

export default CreateTagPage

